import { CardBody, Col, Container, Row } from "reactstrap";

const SpinnerComponent = () => {
  return (
    <CardBody className="loader-box">
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <div className="loader-19"></div>
          </Col>
        </Row>
      </Container>
    </CardBody>
  );
};

export default SpinnerComponent;
